import React, { ReactNode } from 'react';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/layout/Sidebar';
import { BottomNav } from '../components/layout/BottomNav';

interface MainLayoutProps {
  children: ReactNode;
}

/**
 * MainLayout - Visual layout only.
 *
 * Visual layout:
 * - Header: Logo, org selector, Listen Live
 * - Sidebar: Navigation (desktop only, >= md)
 * - Bottom Nav: Navigation (mobile only, < md)
 * - Main content area
 *
 * Note: All providers (Theme, Toast, Kodi) are in AppShell (parent)
 */
export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col h-screen bg-vb-bg-primary dark:bg-vb-bg-primary-dark">
      {/* Header */}
      <Header />

      {/* Content Area with Sidebar/BottomNav */}
      <div className="flex flex-col md:flex-row flex-1 overflow-hidden">
        {/* Sidebar - hidden on mobile */}
        <div className="hidden md:flex h-full">
          <Sidebar />
        </div>

        {/* Main Content - add bottom padding on mobile for nav */}
        <main className="flex-1 overflow-auto pb-16 md:pb-0 bg-vb-bg-primary dark:bg-vb-bg-primary-dark">
          {children}
        </main>
      </div>

      {/* Bottom Nav - visible only on mobile */}
      <div className="md:hidden">
        <BottomNav />
      </div>
    </div>
  );
};
